module.exports = __webpack_public_path__ + "static/media/7P7A8473.f3bf5243.jpg";